export default __webpack_public_path__ + "static/media/rnr-sports-table-3-cn.8a3d6abd.webp";